import React from 'react'
import Header from '../Components/Header/Header'
import Footer from '../Components/Footer/Footer'
import Aboutus from '../Components/AboutUs/Aboutus'

const about = () => {
    return (
        <div>
            <Header />
            <Aboutus />
            <Footer />
        </div>
    )
}

export default about
